// extracted by mini-css-extract-plugin
export var container = "_d3-0";
export var icon = "_d3-1";
export var text = "_d3-2";